import React from "react";
import PropTypes from "prop-types";
import UncontrolledButtonDropdown from "reactstrap/lib/UncontrolledButtonDropdown";

import { gatherClasses } from "../../lib/utils";
import DropdownTrigger from "./DropdownTrigger";
import DropdownMenu from "./DropdownMenu";
import "./dropdown.scss";

const Dropdown = props => {
  const { dataTestId, size, direction } = props;
  return (
    <UncontrolledButtonDropdown
      data-testid={dataTestId}
      inNavbar
      size={size}
      direction={direction}
      className={gatherClasses(props, "oui-btn-droprown")}
    >
      <DropdownTrigger {...props} />
      <DropdownMenu {...props} />
    </UncontrolledButtonDropdown>
  );
};

Dropdown.propTypes = {
  label: PropTypes.string,
  split: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledMain: PropTypes.bool,
  disabledTrigger: PropTypes.bool,
  onClick: PropTypes.func,
  onItemClick: PropTypes.func,
  rightAligned: PropTypes.bool,
  direction: PropTypes.oneOf(["down", "up"]),
  type: PropTypes.oneOf(["primary", "secondary", "tertiary", "link", "icon"]),
  size: PropTypes.oneOf(["lg", "md", "sm"]),
  icon: PropTypes.shape({
    src: PropTypes.string,
    size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
    width: PropTypes.string,
    height: PropTypes.string,
    classes: PropTypes.string,
    onClick: PropTypes.func
  }),
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
          .isRequired,
        disabled: PropTypes.bool,
        onClick: PropTypes.func
      }),
      PropTypes.shape({
        divider: PropTypes.bool
      }),
      PropTypes.shape({
        heading: PropTypes.string,
        items: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
              .isRequired,
            disabled: PropTypes.bool,
            onClick: PropTypes.func
          })
        )
      })
    ])
  ).isRequired,
  maxMenuHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dataTestId: PropTypes.string,
  ariaLabel: PropTypes.string
};

Dropdown.defaultProps = {
  split: false,
  direction: "down",
  disabled: false,
  disabledMain: false,
  disabledTrigger: false,
  rightAligned: false,
  type: "primary",
  size: "md",
  maxMenuHeight: 192,
  dataTestId: "orion-dropdown"
};

Dropdown.displayName = "OrionDropdown";

export default Dropdown;
